/**
 * Data (DD/MM/AAAA no pt-br) no fuso local do navegador, no idioma escolhido pelo usuário.
 * A API devolve ISO-8601 em UTC. Vazio quando a data é desconhecida.
 */
export function formatDeletionDate(iso: string | null | undefined): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat(sessionStorage.getItem('language') || undefined, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
}

/**
 * Data e hora (ex.: 14/10/2026 15:30 no pt-br) no fuso local, no idioma escolhido pelo
 * usuário. Usada onde a janela é medida em horas (exportação de dados). Vazio se inválida.
 */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat(sessionStorage.getItem('language') || undefined, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}
